import { OMNISEARCH_QUERY } from "graphql/queries";
import useQueryData from "hooks/useQueryData";

export default function useOmnisearch({ queryString, limit }) {
  const { data, loading, error } = useQueryData({
    queryName: OMNISEARCH_QUERY,
    keyName: "omnisearch",
    variables: {
      queryString,
      limit,
    },
    skip: !queryString,
  });

  return {
    data: data?.omnisearch || [],
    loading,
    error,
  };
};
